import React, { useEffect, useState } from "react";
import { Card, ListGroup, Badge, Spinner, Row, Col } from "react-bootstrap";
import { messagesService } from "../../services/messagesService";
import AdminUserChat from "../../components/Chat/AdminUserChat";
import UserAvatar from "../../components/Users/UserAvatar/UserAvatar";

import styles from "./Messages.module.css";

const MessagesPage = () => {
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  const refreshChats = async (keepSelectedChatId = null) => {
    const data = await messagesService.getSystemChats();
    const filtered = (data || []).filter((c) => c.hasUserReply);
    setChats(filtered);
    if (keepSelectedChatId) {
      const freshSelected = (data || []).find(
        (c) => c.chatId === keepSelectedChatId,
      );
      if (freshSelected) setSelected(freshSelected);
    }
  };

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const data = await messagesService.getSystemChats();
        const filtered = (data || []).filter((c) => c.hasUserReply);
        setChats(filtered);
        if (!selected && filtered && filtered.length) {
          setSelected(filtered[0]);
        }
      } finally {
        setLoading(false);
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // после открытия диалога backend помечает прочитанным — обновляем список, чтобы сбросить бейдж
    if (!selected?.chatId) return;
    refreshChats(selected.chatId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected?.chatId]);

  return (
    <>
      <h1 className="mb-3">Сообщения </h1>
      <Row className="g-3">
        <Col xs={12} lg={4}>
          <Card className={styles.user_list_wrapper}>
            <Card.Header>Диалоги</Card.Header>
            <Card.Body className="p-0">
              {loading ? (
                <div className="d-flex justify-content-center py-3">
                  <Spinner animation="border" size="sm" />
                </div>
              ) : (
                <ListGroup variant="flush">
                  {chats.map((c) => {
                    const isActive = selected?.chatId === c.chatId;
                    const partner = c.partner || {};
                    const partnerImage = partner.profile_photo?.[0];
                    const last = c.lastMessage;
                    return (
                      <ListGroup.Item
                        key={c.chatId}
                        action
                        active={!!isActive}
                        onClick={() => setSelected(c)}
                        className="d-flex justify-content-left align-items-center"
                      >
                          <UserAvatar image={partnerImage}/>
                        <div className='ms-4'>
                          <div className="fw-semibold">
                            {partner.name || partner.username || "Пользователь"}
                          </div>
                          <div className="small text-muted">
                            {last?.content || "Без текста"}
                          </div>
                        </div>
                        {c.unreadCount > 0 && (
                          <Badge bg="primary" pill>
                            {c.unreadCount}
                          </Badge>
                        )}
                      </ListGroup.Item>
                    );
                  })}
                  {!chats.length && (
                    <ListGroup.Item className="text-muted small">
                      Диалогов пока нет (пользователи ещё не отвечали).
                    </ListGroup.Item>
                  )}
                </ListGroup>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} lg={8}>
          <Card>
            <Card.Header>
              {selected?.partner?.name ||
                selected?.partner?.username ||
                "Выберите диалог"}
            </Card.Header>
            <Card.Body>
              {selected ? (
                <AdminUserChat userId={selected.partner?.mongoId || null} />
              ) : (
                <div className="text-muted small">
                  Выберите пользователя слева, чтобы открыть диалог.
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default MessagesPage;
